import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-upload-modal',
  templateUrl: './upload-modal.component.html',
  styles: []
})
export class UploadModalComponent implements OnInit {

  @Input() title: string;

  @Input() files: Array<File> = [];
  @Input() bytesLoaded: Array<number> = [];
  @Input() bytesTotal: Array<number> = [];
  @Input() percentage: Array<number> = [];
  @Input() status: Array<'pending' | 'success' | 'error'> = [];
  @Input() statusMessage: Array<string> = [];

  Math = Math;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

  getDescription(): string {
    if (this.status.some(s => s === 'pending')) {
      return 'Ihre Daten werden gesendet.';
    } else if (this.status.every(s => s === 'success')) {
      return 'Ihre Daten wurden erfolgreich gesendet.';
    } else  if (this.status.every(s => s === 'error')) {
      return 'Ihre Daten wurden nicht erfolgreich gesendet.';
    } else {
      return '';
    }
  }

  getType(status: 'pending' | 'success' | 'error'): string {
    switch (status) {
      case 'error':
        return 'danger';
      case 'success':
        return 'success';
      case 'pending':
      default:
        return 'primary';
    }
  }

  getStatusMessageComplete(): string {
    if (this.files.length > 1) {
      return (this.status.some(m => m === 'pending'))
        ? 'Bitte warten ...'
        : (this.status.some(m => m === 'error'))
          ? 'Es ist ein Fehler aufgetreten.'
          : (!this.status.some(m => m !== 'success'))
            ? 'Alle Daten wurden erfolgreich versendet.' : '';
    }
  }

  isPending(): boolean {
    return this.status.some(e => e === 'pending');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/upload-modal/upload-modal.component.ts